export const SHARE_AND_RESTRICT_DIALOG_ANALYTICS_SOURCE = 'ShareAndRestrictDialog';

export const USER_PICKER_INPUT_ID = 'share-and-restrict-dialog-user-picker-input';

/** Content types eligible for access link UI. New types must be explicitly added. */
export const ACCESS_LINK_ENROLLED_CONTENT_TYPES: readonly string[] = ['page'];

export const SAC_CONTENT_ADD_REMOVE_DOCUMENTATION =
	'https://support.atlassian.com/confluence-cloud/docs/add-or-remove-page-restrictions';
export const SAC_CONTENT_PERMS_MANAGEMENT_DOCUMENTATION =
	'https://support.atlassian.com/confluence-cloud/docs/manage-permissions-on-the-page-level/';
